import type { TimelineHour } from "../../api/types";
import { cn } from "../../lib/cn";
import { type PrecipType, PRECIP_BASE, hourPop, tintOpacity } from "../../lib/timelineTint";

interface Props {
  hours: TimelineHour[];
  layout: "collapsed" | "expanded";
  types: PrecipType[];
}

function TrackCell({ hour, type }: { hour: TimelineHour; type: PrecipType }) {
  const pop = hourPop(hour, type);
  const opacity = tintOpacity(pop);
  if (opacity <= 0) {
    return <div className="h-full flex-1 bg-surface-container-high" />;
  }
  return <div className="h-full flex-1" style={{ backgroundColor: PRECIP_BASE[type], opacity }} />;
}

function TrackRow({
  hours,
  type,
  heightClass,
}: {
  hours: TimelineHour[];
  type: PrecipType;
  heightClass: string;
}) {
  return (
    <div className={cn("flex w-full gap-px", heightClass)}>
      {hours.map((hour) => (
        <TrackCell key={`${type}-${hour.localTime}`} hour={hour} type={type} />
      ))}
    </div>
  );
}

export default function PrecipTracksRow({ hours, layout, types }: Props) {
  if (types.length === 0) {
    return <TrackRow hours={hours} type="rain" heightClass="h-[11px]" />;
  }

  if (layout === "collapsed") {
    const primary = types[0];
    return <TrackRow hours={hours} type={primary} heightClass="h-[11px]" />;
  }

  return (
    <div className="flex flex-col gap-px">
      {types.map((type) => (
        <TrackRow key={type} hours={hours} type={type} heightClass="h-1" />
      ))}
    </div>
  );
}
